import script from "./BaseAccordeon.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAccordeon.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAccordeon.vue?vue&type=style&index=0&id=4c2ee8d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2ee8d0"]])

export default __exports__